import type { FC } from 'react'
import type { CardMeta } from '../dashboard/types'
import type { DashboardVoyage as Voyage } from './types'
import CardInfoButton from './CardInfoButton'
import { upcomingDashboardVoyages } from './dashboardData'

type CriticalEventsProps = {
  activeVoyages: Voyage[]
  onViewAll: () => void
}

const meta: CardMeta = {
  description: 'Upcoming saved voyage arrival ETAs, ordered nearest first.',
  endpoint: 'GET /voyages',
  logic: 'Future saved ETAs on active voyages, nearest first. Missing dates are excluded. Date proximity does not establish risk severity.',
}

const EventRow: FC<{ day: string; mon: string; title: string; location: string; time: string }> = ({ day, mon, title, location, time }) => {
  return (
    <div className='d-flex align-items-start gap-3'>
      <div className='text-center flex-shrink-0' style={{ minWidth: '28px' }}>
        <div className='fw-bold text-primary' style={{ fontSize: '12px' }}>{day}</div>
        <div className='text-muted fw-semibold' style={{ fontSize: '8px' }}>{mon}</div>
      </div>
      <div className='flex-1 min-w-0'>
        <div className='fw-semibold text-dark' style={{ fontSize: '10px' }}>{title}</div>
        <div className='text-muted' style={{ fontSize: '9px' }}>{location}</div>
      </div>
      <div className='text-end flex-shrink-0'>
        <div className='text-muted' style={{ fontSize: '9px' }}>{time}</div>

      </div>
    </div>
  )
}

const CriticalEvents: FC<CriticalEventsProps> = ({ activeVoyages, onViewAll }) => {
  const voyageEvents = upcomingDashboardVoyages(activeVoyages).slice(0, 5)

  return (
    <div className='flex flex-col flex-1'>
      <div className='card flex-1' style={{ borderRadius: '16px' }}>
        <div className='card-body'>
          <div className='d-flex align-items-center gap-2 mb-3'>
            <h6 className='fw-bold text-dark mb-0' style={{ fontSize: '13px' }}>Upcoming Critical Events</h6>
            <span className='ms-auto d-flex align-items-center gap-2'>
              <CardInfoButton meta={meta} />
              <a href='#' className='fw-bold' style={{ fontSize: '10px' }} onClick={(e) => { e.preventDefault(); onViewAll(); }}>View all</a>
            </span>
          </div>
          <div className='d-flex flex-column gap-3'>
            {voyageEvents.length > 0 ? (
              voyageEvents.map((v, i) => {
                const endDate = new Date(v.eta!)
                const diffDays = Math.ceil((endDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24))
                return (
                  <EventRow key={i}
                    day={endDate.toLocaleDateString('en-GB', { day: '2-digit' })}
                    mon={endDate.toLocaleDateString('en-GB', { month: 'short' })}
                    title={`${v.vessel?.fleet_name || 'Vessel'} · ${v.voyageNumber || `Voyage #${v.id}`}`}
                    location={v.arrivalPort || '—'}
                    time={`in ${diffDays} day${diffDays !== 1 ? 's' : ''}`} />
                )
              })
            ) : (
              <div className='text-center text-muted py-4' style={{ fontSize: '11px' }}>
                <div className='mb-1'>No upcoming critical events</div>
                <div style={{ fontSize: '10px' }}>Events from active voyages will appear here</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CriticalEvents
